/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 22/11/21
 */
import React, {memo, useMemo} from 'react';
import PropTypes from 'prop-types';
import PreviewTextType from '@/modules/templates/components/Registers/PreviewTextType';
import PreviewNumberType from '@/modules/templates/components/Registers/PreviewNumberType';
import PreviewAuthorType from '@/modules/templates/components/Registers/PreviewAuthorType';
import PreviewHourType from '@/modules/templates/components/Registers/PreviewHourType';
import PreviewDateType from '@/modules/templates/components/Registers/PreviewDateType';
import PreviewSelectType from '@/modules/templates/components/Registers/PreviewSelectType';

const WrapperFieldType = ({fieldType, parameter}) => {

  const render = useMemo(() => {
    switch (fieldType) {
      case 'number':
        return <PreviewNumberType parameter={parameter} />;
      case 'hour':
        return <PreviewHourType parameter={parameter} />;
      case 'counter':
        return <PreviewNumberType parameter={parameter} />;
      case 'author':
        return <PreviewAuthorType parameter={parameter} />;
      case 'select':
        return <PreviewSelectType parameter={parameter} />;
      case 'date':
        return <PreviewDateType parameter={parameter} />;
      default:
        return <PreviewTextType parameter={parameter} />;
    }
  }, [fieldType, parameter]);

  return (
    <div className="py-2">{render}</div>
  );
};

WrapperFieldType.propTypes = {
  fieldType: PropTypes.string,
  type: PropTypes.string,
  parameter: PropTypes.object,
  sectionId: PropTypes.string,
};

export default memo(WrapperFieldType);
